import { render, staticRenderFns } from "./FamilyInfo.vue?vue&type=template&id=fade17d6&"
import script from "./FamilyInfo.vue?vue&type=script&lang=ts&"
export * from "./FamilyInfo.vue?vue&type=script&lang=ts&"
import style0 from "./FamilyInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports